import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const useActivityLogPreferences = function useActivityLogPreferences() {
    let { enabled = true } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.ActivityLogPreferences
        ],
        queryFn: ()=>api.activityLog.getPreferences(),
        enabled
    });
    return {
        preferences: data,
        isLoading
    };
};
